import * as actionTypes from './types';


const INITIAL_KEY_STATE = {
	value: null
};

const INITIAL_STATE = {
	value: {
		visible: false,
		isThemeAvailable: false,
		isGuestTokenReady: false,
		theme: 'universal',
		primary: '',
		secondary: '',
		template: 'food',
		currency: '₹',
		role: 'Reader',
		language: 'en-US',
		header: true,
		footer: true,
		sidebar: true,
		tenantName: 'logistics',
		tenantId: -1, // DO NOT CHANGE THE VALUE
		getQuote: 'close',
		getRegistry: 'close',
		getDeleteModal: 'close',
		getUploadFiles: 'close',
		getCommonModal: 'close',
		accountData: {},
		quoteData: {},
		cargoLead: {},
		isMenu: false
	},
	set: INITIAL_KEY_STATE,
};


const settingsReducer = (state = INITIAL_STATE, action: any) => {
	const { payload } = action;
	switch (action.type) {
		case actionTypes.SET_DATA:

			return {
				value: {
					...state.value,
					...payload
				}
			};
		default:
			return state;
	}
};

export default settingsReducer;
